import { Component } from "@angular/core";
import { ConfirmationService, MessageService } from "primeng/api";
import { FilingRecordsService } from "../../../../api/services/filing-records.service";
import { FilingRecords } from "../../../../api/models/filing-records";
import { FormType } from "../../../../api/models/form-type";
import { FormFilterForException } from "../../../../api/models/form-filter-for-exception";
import { preventLeadingSpaceKey } from "src/core/utils/input-validation.utils";
@Component({
  selector: "exception-app-discard",
  // imports: [],
  templateUrl: "./discard.component.html",
  styleUrl: "./discard.component.css",
  standalone: false,
})
export class ExceptionDiscardComponent {
  filingRecords: FilingRecords[] = [];
  first = 0;
  isLoading: boolean = false;
  rows = 10;
  filingIdInput?: number;
  issuerNameInput?: string;
  formTypes = FormType.values();
  selectedFormType: FormType | null = null;
  rangeDates: Date[] | undefined;
  startDateInput?: Date | string;
  endDateInput?: Date | string;
  readonly paginator = { pageSize: 10, pageNumber: 1, totalCount: 0 };

  constructor(
    private _filingRecordService: FilingRecordsService,
    private _messageService: MessageService,
    private _confirmationService: ConfirmationService
  ) {}
  pageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
  }
  loadData(event: any) {
    if (event.first > 0 && this.paginator.pageSize != event.rows) {
      this.paginator.pageNumber = 1;
      this.first = 0;
    } else {
      this.paginator.pageNumber = event.first / event.rows + 1;
      this.first = event.first;
    }
    this.paginator.pageSize = event.rows;
    this.getFilingWithFilingFilter();
  }
  onDateChange() {
    if (this.rangeDates && this.rangeDates.length === 2) {
      const formatDate = (date: Date) => date.toLocaleDateString("en-CA"); // yyyy-mm-dd (local)
      this.startDateInput = formatDate(this.rangeDates[0]);
      this.endDateInput = formatDate(this.rangeDates[1]);
      this.onSearch();
    } else {
      this.startDateInput = undefined;
      this.endDateInput = undefined;
      this.onSearch();
    }
  }
  onSearch() {
        const fid = String(this.filingIdInput ?? '').trim();
  if (fid && !/^\d+$/.test(fid)) {
    return;
  }
    this.first = 0;
    this.paginator.pageNumber = 1;
    this.getFilingWithFilingFilter();
  }
  preventSpaceKey(event: KeyboardEvent): void {
      preventLeadingSpaceKey(event);
    }
  getFilingWithFilingFilter() {
    const params: FormFilterForException = {
      pageNumber: this.paginator.pageNumber,
      pageSize: this.paginator.pageSize,
      issuerName: this.issuerNameInput,
      formType: this.selectedFormType as any,
      filingId: this.filingIdInput,
      startDate:
        this.startDateInput instanceof Date
          ? this.startDateInput.toISOString()
          : this.startDateInput,
      endDate:
        this.endDateInput instanceof Date
          ? this.endDateInput.toISOString()
          : this.endDateInput,
    };
    this.isLoading = true;
    this._filingRecordService.getDiscardFilingRecordsList(params).subscribe({
      next: (value) => {
        this.filingRecords = value;
      },
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          summary: err.error.message,
          severity: "error",
        });
      },
      complete: () => {
        this.paginator.totalCount =
          this.filingRecords.length > 0 ? this.filingRecords[0].totalCount! : 0;
        this.isLoading = false;
      },
    });
  }
  restoreFiling(filing: any) {
    this._confirmationService.confirm({
      message: `Are you sure you want to restore filing #${filing.filingId}?`,
      header: "Confirm Restore",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        this.isLoading = true;
        const reason = "Filing Incorrectly Discarded";

        const params = {
          recordId: filing.recordId,
          reason: reason,
        };

        this._filingRecordService
          .revertDiscardFilingRecordResponse(params)
          .subscribe({
            next: (success) => {
              if (success) {
                this._messageService.add({
                  severity: "success",
                  summary: "Filing Restored",
                  detail: `Filing #${filing.filingId} has been successfully restored.`,
                });
                this.getFilingWithFilingFilter();
              } else {
                this._messageService.add({
                  severity: "warn",
                  summary: "Failed to Restore",
                  detail: `Filing #${filing.filingId} could not be restored.`,
                });
              }
            },
            error: (err) => {
              this._messageService.add({
                severity: "error",
                summary: "Error",
                detail:
                  err.error.message ||
                  "Something went wrong while restoring the filing.",
              });
              this.isLoading = false;
            },
            complete: () => {
              this.isLoading = false;
            },
          });
      },
    });
  }
}
